import { createFileRoute } from "@tanstack/react-router";
import { legacyRedirectTo } from "@/lib/legacy-redirect";

// Legacy URL /integrations → redirect to /app/sources.
export const Route = createFileRoute("/integrations/")({
  beforeLoad: legacyRedirectTo("/app/sources"),
  component: () => null,
});
